'use client';

/**
 * Web `TurnkeySessionSteward` — binds `@turnkey/react-wallet-kit`'s
 * `useTurnkey()` surface into the platform-neutral steward core
 * (`src/auth/turnkey/use-session-steward.ts`), which owns the rolling
 * session refresh + dead-session reconcile. Mounted inside
 * `TurnkeyModalBridge` (below `WalletKitProvider`, so its renders cannot
 * churn the kit's memoized config/callbacks).
 */
import { c as _c } from "react/compiler-runtime";
import { ClientState, useTurnkey } from '@turnkey/react-wallet-kit';
import { useTurnkeySessionSteward } from '../../../../auth/turnkey/use-session-steward.js';
export function TurnkeySessionSteward(t0) {
  const $ = _c(12);
  const {
    onAuthEvent
  } = t0;
  const {
    clientState,
    config,
    getSession,
    refreshSession
  } = useTurnkey();
  const t1 = clientState === ClientState.Ready;
  let t2;
  if ($[0] !== getSession) {
    t2 = async () => getSession();
    $[0] = getSession;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== refreshSession) {
    t3 = async params => refreshSession(params);
    $[2] = refreshSession;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = config?.auth?.sessionExpirationSeconds;
  let t5;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      clientReady: t1,
      getSession: t2,
      refreshSession: t3,
      sessionExpirationSeconds: t4
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const kit = t5;
  let t6;
  if ($[9] !== kit || $[10] !== onAuthEvent) {
    t6 = {
      kit,
      onAuthEvent
    };
    $[9] = kit;
    $[10] = onAuthEvent;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useTurnkeySessionSteward(t6);
  return null;
}